import { View } from "@gaming/srvg-classes-core";
import { ManualOverlayContainerView } from "./ManualOverlayContainerView";
import { TimelineOverlayContainerView } from "./TimelineOverlayContainerView";
import { OverlayButtonbarView } from "./OverlayButtonbarView";

export class OverlayContainerContainerView extends View {
    manualOverlayContainerView:ManualOverlayContainerView;
    timelineOverlayContainerView:TimelineOverlayContainerView;
    overlayButtonbarView:OverlayButtonbarView;

    constructor(options) {
        options = options || {};
        options.name = options.name || 'overlayContainerContainerView';
        options.selector = '#' + options.name;
        super(options);

        this.manualOverlayContainerView = this.addSubView( new ManualOverlayContainerView({
            selector: '#manualOverlayContainerView'
        }) );

        this.timelineOverlayContainerView = this.addSubView( new TimelineOverlayContainerView({
            selector: '#timelineOverlayContainerView'
        }) );

        this.overlayButtonbarView = this.addSubView( new OverlayButtonbarView({selector: '#buttonbarView'}) );
    }
}